import Table, { SORTER_STRING } from '../components/Table';
import { BrandBadge } from '../brands';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from 'react';
import { fetch } from '../store/shownDataSlice';
import * as common from './common';



const TODAY = new Date();

function MyJobsToday({  }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const _data = useSelector((state) => state.shownData.myUpcomingJobs);
    const data = _data ? _data.filter(row => common.sameDay(TODAY, new Date(row["query_start"] * 1000))) : [];
    const sortedData = [...data].sort((a, b) => {
        return a["query_start"] > b["query_start"] ? 1 : -1;
    });


    
    return (
        <Table
            style={{ width: '100%' }}
            columnNames={[
                "Reisi kuupäev",
                "Sihtkohad",
                "Peatumisi",
                "Buss",
                "Reisijad",
            ]}
            columnRenderers={[
                (row) => (<a onClick={() => navigate("/platform/job/" + row["query_id"])}>{common.displayDepart(row)}</a>),
                (row) => (<p style={{ maxWidth: 192, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{row["query_brand"] === "triobuss" && <><BrandBadge brand={row["query_brand"]} />&nbsp;</>}{common.displayPrettyRoute(row)}</p>),
                (row) => (<p>{common.displayRouteStops(row)}</p>),
                (row) => (<p>{row["bus_name"] || '-'}</p>),
                (row) => (<p>{row["query_passengers"]}</p>),
            ]}
            data={sortedData}
        />
    );
}

export default MyJobsToday;